// extracted by mini-css-extract-plugin
module.exports = {"chips":"_1EQiX7Mi","selected":"_3tfNfwKl","unselected":"_1XCObzk6"};